import(/* webpackMode: "eager" */ "/codebuild/output/src3033254012/src/apps/fanychance/src/components/layouts/PageHeader/PageHeader.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3033254012/src/apps/fanychance/src/features/contact/components/ContactForm/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3033254012/src/apps/fanychance/src/features/contact/components/ContactHeaderSideNode/ContactHeaderSideNode.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3033254012/src/node_modules/next/dist/client/link.js");
